export var version = {
  lib: '2.10082.7-beta',
  product: '2.10082.7-beta',
  supportedApiVersion: 2
};



// WEBPACK FOOTER //
// ./src/misc/Version.ts